import { ENVIRONMENT } from 'types';

export function isProd(env: ENVIRONMENT) {
	return ENVIRONMENT.PRODUCTION === env;
}

export function isDev(env: string = globalThis.location.hostname) {
	switch (env.toLowerCase()) {
		case ENVIRONMENT.DEV:
		case ENVIRONMENT.DEVELOPMENT:
		case 'localhost':
			return true;
		default:
			return false;
	}
}

export function envURL(env: ENVIRONMENT) {
	switch (env) {
		case ENVIRONMENT.DEV:
		case ENVIRONMENT.DEVELOPMENT:
			return '-dev';
		case ENVIRONMENT.TEST:
			return '-test';
		default:
			return '';
	}
}
